module.exports = {
    MAXIMUM_DECIMAL_PRECISION: 8
};
